import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { NumberingList } from '../TitleList';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectBalelist, selectChanllanId, selectClothIsInfo, selectClothIssue, selectCutReturnlist, selectEmployees, selectFirm, selectItemAvg, selectItems, selectMasterMlist, selectMemoNo, selectSONOinfolist } from '../Selectors/Master/ItemSelectors';
import { fetchSORegister } from '../../Store/PHPSlice/Sale/SaleOrder';
import { InsertCuttingEntry } from '../../Store/PHPSlice/Cutting/clothIssue';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { errorStyles } from '../../Utils/table';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchCuttingReturnlist2, fetchMasterMlist } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { fetchMemoNo } from '../../Store/PHPSlice/Cutting/SOMcutting';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Preview from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchCuttingMemo, fetchNumberingMemo, InsertNumberingEntry } from '../../Store/PHPSlice/Numbering/numberingApi';
import { selectCtInwardMemo, selectNumMemo } from '../Selectors/TrackSelector/TrackSelector';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import SOMaterialOut from '../Sale/SOMaterialOut';
import SOMaterialOutView from '../Sale/View/SOMaterialOutView';


const NumberingEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        firmId: '',
        dt: getCurrentDate(),
        firmNm: '',
        memo: '',
        sono: '0',
        soId: '0',
        empNm: '',
        totQty: '',
        userId: userdata?.ID,
        reMemo: ''
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        master: fetchMasterMlist,
        sono: fetchSORegister,
        firm: fetchCompanyData,
        empNm: fetchEmployeeData
        // Add more mappings if needed
    };
    const [itemSize, setItemSize] = useState([]);
    const [gQty, setGQty] = useState([]);
    const [inputValues, setInputValues] = useState([]);

    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const [tableNumSize, setTableNumSize] = useState([]);
    const [itemlist, setItemlist] = useState([]);
    const [sizeValues, setSizeValues] = useState([]);
    const [saveMaterialData, setSaveMaterialData] = useState([]);
    const [saveMatStkData, setSaveMatStkData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);

    const balelist = useSelector(selectBalelist);

    const masterMlist = useSelector(selectMasterMlist);
    const inwardMemo = useSelector(selectCtInwardMemo);
    const numMemo = useSelector(selectNumMemo);
    const inwdata = useSelector(selectCutReturnlist);
    const empList = useSelector(selectEmployees);
    const departList = useSelector(selectDaparement);
    const firmlist = useSelector(selectFirm);

    // console.log(itemSize)
    useEffect(() => {
        dispatch(fetchMasterMlist());
        // dispatch(fetchCuttingMemo());
        dispatch(fetchNumberingMemo());
        dispatch(fetchEmployeeData());
        dispatch(fetchDepartmentData());
        dispatch(fetchCompanyData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (numMemo.data) {
            const item = numMemo.data.memo;
            setFormData(prev => ({
                ...prev,
                memo: item
            }))
        }
    }, [numMemo]);

    useEffect(() => {
        if (inwdata?.data?.length > 0) {
            const items = inwdata?.data[0];
            // console.log(items);
            setFormData(prev => ({
                ...prev,
                itemNm: items?.itemNm,
                item: items?.itemId,
                mCloth: items.mclothNm,
                mclothId: items.mcloth,
                m1clothNm: items.m1clothNm,
                m1clothId: items.m1cloth,
                m2clothNm: items.m2clothNm,
                m2clothId: items.m2cloth,
                m3clothNm: items.m3clothNm,
                m3clothId: items.m3cloth,
                soId: items.soId,
                sono: items.sono,
                reMemo: items?.return_Memo
                // firmNm: items?.firmNm || '',
                // firmId: items?.firmId || '0'
            }))
        }
        if (inwdata?.returnInfo2?.length > 0) {
            const sizeArray = inwdata?.returnInfo2?.map(e => e.size);
            const givenQtyArray = inwdata?.returnInfo2?.map(e => e.numqty);
            const returnQtyArray = inwdata?.returnInfo2?.map(e => e.numbqty);
            const returnQtyArray2 = inwdata?.returnInfo2?.map(e => e.nqty);
            const totQtys = returnQtyArray2?.reduce((acc, sum) => acc + parseFloat(sum), 0);


            setItemSize(sizeArray);
            setGQty(returnQtyArray);
            setInputValues(returnQtyArray2);
            setFormData(prev => ({
                ...prev,
                totQty: totQtys
            }));
        }
    }, [inwdata]);

    const handleQtychange = (index, e) => {
        const value = e.target.value;
        if (!/^\d*$/.test(value)) return;

        const maxQty = parseInt(gQty[index], 10);
        const enteredQty = parseInt(value, 10);

        if (enteredQty > maxQty) {
            alert(`Entered quantity (${enteredQty}) cannot be greater than given quantity (${maxQty})`);
            return;
        }
        const updated = [...inputValues];
        updated[index] = value;
        const sizeval = itemSize[index];
        const obj = {
            size: sizeval,
            issqty: value
        };

        setSizeValues(prev => {
            const exists = prev.some(item => item.size === sizeval);
            if (exists) {
                return prev; // do not add duplicate
            }
            return [...prev, obj];
        });

        setInputValues(updated);


        const totalQty = updated.reduce((sum, val) => {
            const num = parseInt(val, 10);
            return sum + (isNaN(num) ? 0 : num);
        }, 0);

        setFormData(prev => ({
            ...prev,
            totQty: totalQty
        }));
    };

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        // console.log(dropdownType)
        switch (dropdownType) {

            case 'firmId':
                if (value) {
                    dispatch(fetchCuttingMemo(value));

                }
                break;
            case 'cutInwId':
                if (value) {
                    dispatch(fetchCuttingReturnlist2(value));
                    // fetchCuttingItems(value);
                }
                break;

            case 'itemId':
                if (value) {
                    // dispatch(fetchCuttingReturnlist2(value));

                }
                break;
            default:
                break;
        };
    };

    const fetchCuttingItems = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getCuttingItemsByctId&ctId=${id}`);
            setItemlist(response?.data?.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    function mergeArrays(a, b) {
        return a.map((valueA, index) => {
            const valueB = b[index];

            // Convert the values to numbers for comparison
            const numA = Number(valueA) || 0;
            const numB = Number(valueB) || 0;

            // Check the conditions
            if (numA !== 0 && numB === 0) {
                return valueA;
            } else if (numA === 0 && numB !== 0) {
                return valueB;
            } else if (numA !== 0 && numB !== 0) {
                return valueA; // You can choose either valueA or valueB here since both are non-zero
            } else {
                return '0'; // Both are zero
            }
        });
    };

    function convertIntoOneObject(formData, multiData, saveMatStkData) {
        return {
            dt: formData.dt,
            memo: formData.memo,
            cutInwId: formData.cutInwId,
            item: formData.item,
            mClothId: formData.mclothId,
            m1clothId: formData.m1clothId,
            m2clothId: formData.m2clothId,
            m3clothId: formData.m3clothId,
            empId: formData.empNm,
            userId: formData.userId,
            finalqty: formData.totQty,
            soId: formData.soId,
            multiData: multiData,
            materialData: saveMatStkData,
            firmId: formData.firmId
        };
    };


    const handleSubmit = async (e) => {
        e.preventDefault();


        if (formData.empNm.trim() === '') {
            alert('Select Employee');
        } else {

            setLoading(true);
            try {
                const multiData = itemSize.map((size, index) => ({
                    size: size,
                    returnQty: inputValues[index] || "0",
                    givenQty: gQty[index] || "0"
                }));

                const finalObj = convertIntoOneObject(formData, multiData, saveMatStkData);
                // console.log(finalObj);

                const result = await dispatch(InsertNumberingEntry(finalObj)).unwrap();
                console.log('POST request successful!', result);
                // alert("Numbering added successfully");
                // window.location.reload();
                if (result.status === "success") {
                    alert(result.msg);
                    window.location.reload();
                } else {
                    alert(result.msg);
                }

            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }
        }


    };

    const handleNewEmployee = () => {
        window.open(`/new-emp-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownEmployeelist = [
        {
            label: 'Employee',
            id: 'empNm',
            options: empList?.data?.filter((item) => item.departNm === 'NUMBERING') || [],
            value: formData.empNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNewEmployee(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('empNm'),
            handleDropdownClose: () => handleDropdownClose('empNm'),
        }
    ];


    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Cutting Memo No',
            id: 'cutInwId',
            options: inwardMemo?.data || [],
            value: formData.cutInwId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cutInwId', value: newValue ? newValue.ID : '' } }, 'cutInwId'),
            getOptionLabel: (option) => `${option.ctMemo} - ${option.itemNm}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        // {
        //     label: 'Item',
        //     id: 'itemId',
        //     options: itemlist || [],
        //     value: formData.itemId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
        //     getOptionLabel: (option) => option.itemNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     bold: true
        // }
    ];

    const handleSaveMaterialData = (data) => {
        // console.log(data);
        setSaveMatStkData(data);
    };

    const handleSelectRow = (index) => {
        setSelectedRows(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };

    const handleRemoveSelected = () => {
        if (selectedRows.length === 0) return;

        if (!window.confirm('Remove selected rows?')) return;

        setSaveMatStkData(prev =>
            prev.filter((_, index) => !selectedRows.includes(index))
        );

        setSelectedRows([]); // reset
    };


    return (
        <>
            <Titlebar data={NumberingList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Numbering Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No', name: 'memo', type: 'readOnly' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }


                                {/* <Grid item xs={12} md={6}>

                                </Grid> */}

                                {/* {[
                                { label: 'Barcode', name: 'barcd', type: 'barcd' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))} */}


                                {[

                                    { label: 'SO No.', name: 'sono', type: 'readOnly' },
                                    { label: 'Item', name: 'itemNm', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Main Cloth', name: 'mCloth', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Match-1', name: 'm1clothNm', type: 'm1Cloth' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {[
                                    { label: 'Match-2', name: 'm2clothNm', type: 'm2Cloth' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'Match-3', name: 'm3clothNm', type: 'm3Cloth' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                {/* {[
                                    { label: '', name: '', type: '' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            </Grid>
                                            <Grid item xs>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))} */}

                                {
                                    dropdownEmployeelist && dropdownEmployeelist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }
                                {[

                                    { label: 'Total Qty.', name: 'totQty', type: 'readOnly' },
                                    { label: 'Cutting Return Memo', name: 'reMemo', type: 'readOnly' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || '0'}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                {/* {
                                    dropdownMemberlist  && dropdownMemberlist ?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }   */}



                                {itemSize?.length > 0 && (
                                    <Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                        {itemSize.map((size, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {size}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {formData?.ordType !== '0' && (
                                                        <TableRow>
                                                            <TableCell
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                Given Qty.
                                                            </TableCell>
                                                            {gQty.map((qty, index) => (
                                                                <TableCell
                                                                    key={index}
                                                                    sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                    align='center'
                                                                >
                                                                    {qty}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    )}

                                                    <TableRow>
                                                        <TableCell
                                                            sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            Issue Qty.
                                                        </TableCell>
                                                        {inputValues?.map((val, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 0.4, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                <input
                                                                    type="number"
                                                                    value={val}
                                                                    placeholder="0"
                                                                    onChange={(e) => handleQtychange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                )}


                                {formData.item && formData.soId && saveMatStkData.length === 0 ?
                                    <SOMaterialOut itemId={formData.item} soId={formData.soId} qtyArr={inputValues} onSave={handleSaveMaterialData} />
                                    : null
                                }

                                {
                                    saveMatStkData.length > 0 &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <Button variant="contained" color="primary" onClick={handleRemoveSelected} disabled={selectedRows.length === 0}>Delete</Button>
                                        </Grid>

                                        <SOMaterialOutView array={saveMatStkData} selectedRows={selectedRows} onSelectRow={handleSelectRow} />
                                    </>

                                }



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default NumberingEntry;
